import { useEffect } from "react";

export default function useScrollIntoView(
	dependency: number | boolean,
	parentRef: HTMLElement | HTMLDivElement | null | undefined,
	childRef: HTMLDivElement | HTMLElement | null
) {
	useEffect(() => {
		if (parentRef && childRef) {
			// parent top and bottom that's in view
			const pTop = parentRef.scrollTop;
			const pBottom = pTop + parentRef.clientHeight;

			// child top and bottom that's active
			const cTop = childRef.offsetTop;
			const cBottom = cTop + childRef.clientHeight;

			// check if out of view
			if (cTop < pTop) {
				parentRef.scrollTop -= pTop - cTop;
			} else if (cBottom > pBottom) {
				parentRef.scrollTop += cBottom - pBottom;
			}
		}
	}, [dependency, parentRef, childRef]);
}
